import { createContext } from 'react';
import { ViewModel } from '@steelbuy/ts-shared';

import { CollectionDataProviderValue, defaultCollectionDataValue } from './CollectionDataProviderValue';

export const createCollectionDataContext = <Model extends ViewModel>(): React.Context<
    CollectionDataProviderValue<Model>
> => createContext<CollectionDataProviderValue<Model>>(defaultCollectionDataValue);
